/*
 * Oft zusammen gekauft (Frequently bought together)
 * - Laedt Komplementaerprodukte (Search & Discovery) lazy nach
 * - Fortschrittsleiste aus scrollLeft/scrollWidth
 * - Add-to-Cart via AJAX – aktualisiert Warenkorb LAUTLOS (Drawer/Notification oeffnet NICHT)
 * - "Im Warenkorb"-Badge + kurzes "Hinzugefuegt"-Feedback, live via /cart.js + PUB_SUB_EVENTS
 * - A11y: Erfolg wird ueber eine unsichtbare aria-live-Region gemeldet
 */
if (!customElements.get('complementary-fbt-recommendations')) {
  customElements.define(
    'complementary-fbt-recommendations',
    class ComplementaryFbt extends HTMLElement {
      constructor() {
        super();
        this.loaded = false;
      }

            connectedCallback() {
        // Inhalt kommt jetzt serverseitig aus dem Search-&-Discovery-Metafeld
        if (this._inited) return;
        this._inited = true;
        this.init();
      }

      disconnectedCallback() {
        if (this._cartSub) { this._cartSub(); this._cartSub = null; }
        if (this._pageshow) { window.removeEventListener('pageshow', this._pageshow); this._pageshow = null; }
      }

      init() {
        this.slider = this.querySelector('.complementary-fbt__slider');
        this.progress = this.querySelector('.complementary-fbt__progress');
        this.thumb = this.querySelector('.complementary-fbt__progress-thumb');

        if (!this.status) {
          this.status = document.createElement('p');
          this.status.className = 'visually-hidden';
          this.status.setAttribute('role', 'status');
          this.status.setAttribute('aria-live', 'polite');
          this.appendChild(this.status);
        }

        this.initProgress();
        this.initAddButtons();

        this.syncCartState();
        if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && !this._cartSub) {
          this._cartSub = subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => this.syncCartState());
        }
        if (!this._pageshow) {
          this._pageshow = (e) => { if (e.persisted) this.syncCartState(); };
          window.addEventListener('pageshow', this._pageshow);
        }
      }

      /* ---------- Fortschrittsleiste ---------- */
      initProgress() {
        if (!this.slider || !this.progress || !this.thumb) return;
        this.updateProgress = this.updateProgress.bind(this);
        this.slider.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
        window.addEventListener('resize', this.updateProgress, { passive: true });
        window.addEventListener('load', this.updateProgress, { passive: true });
        requestAnimationFrame(this.updateProgress);
      }

      onScroll() {
        if (this._raf) return;
        this._raf = requestAnimationFrame(() => {
          this._raf = null;
          this.updateProgress();
        });
      }

      updateProgress() {
        if (!this.slider) return;
        const { scrollWidth, clientWidth, scrollLeft } = this.slider;
        const overflow = scrollWidth - clientWidth;

        if (overflow <= 1) {
          this.progress.hidden = true;
          return;
        }
        this.progress.hidden = false;

        const widthPct = (clientWidth / scrollWidth) * 100;
        const progressRatio = scrollLeft / overflow;
        const leftPct = progressRatio * (100 - widthPct);

        this.thumb.style.width = widthPct + '%';
        this.thumb.style.left = leftPct + '%';
      }

      /* ---------- Warenkorb-Status ---------- */
      syncCartState() {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((cart) => {
            const ids = new Set((cart.items || []).map((i) => i.product_id));
            this.querySelectorAll('.complementary-fbt__card[data-product-id]').forEach((card) => {
              const inCart = ids.has(parseInt(card.dataset.productId, 10));
              card.classList.toggle('is-in-cart', inCart);
              if (!inCart) card.classList.remove('is-just-added');
            });
          })
          .catch(() => {});
      }

      markAdded(button) {
        const card = button.closest('.complementary-fbt__card');
        if (card) {
          card.classList.add('is-in-cart', 'is-just-added');
          window.clearTimeout(card._fbtTimer);
          card._fbtTimer = window.setTimeout(() => card.classList.remove('is-just-added'), 2000);

          if (this.status) {
            const title = card.querySelector('.complementary-fbt__title');
            const added = card.querySelector('.fbt-badge-added');
            this.status.textContent = `${title ? title.textContent.trim() : ''} ${added ? added.textContent.trim() : ''}`.trim();
          }
        }
        button.classList.add('is-added');
        window.clearTimeout(button._fbtTimer);
        button._fbtTimer = window.setTimeout(() => button.classList.remove('is-added'), 1500);
      }

      /* ---------- Add to cart ---------- */
      initAddButtons() {
        this.querySelectorAll('button.complementary-fbt__add[data-variant-id]').forEach((btn) => {
          btn.addEventListener('click', (e) => this.addToCart(e.currentTarget));
        });
      }

      getCart() {
        return (
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer')
        );
      }

      // Warenkorb-Inhalt + Bubble aktualisieren, OHNE Drawer/Notification zu oeffnen
      updateCartSilently(cart, response) {
        if (!cart || typeof cart.getSectionsToRender !== 'function' || !response.sections) {
          this.refreshCartBubble();
          return;
        }

        const innerOf = (html, selector) => {
          const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
          return el ? el.innerHTML : null;
        };

        cart.getSectionsToRender().forEach((section) => {
          const html = response.sections[section.id];
          if (!html) return;
          const target = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          if (!target) return;
          const inner = innerOf(html, section.selector || '.shopify-section');
          if (inner !== null) target.innerHTML = inner;
        });

        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');

        if (cart.tagName === 'CART-DRAWER' && typeof cart.close === 'function') {
          const overlay = cart.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', cart.close.bind(cart));
        }
      }

      addToCart(button) {
        if (button.classList.contains('is-loading')) return;
        const variantId = button.dataset.variantId;
        if (!variantId) return;

        const cart = this.getCart();
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);

        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append('sections', cart.getSectionsToRender().map((s) => s.id));
          formData.append('sections_url', window.location.pathname);
        }

        const config = {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        };

        const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

        fetch(addUrl, config)
          .then((res) => res.json())
          .then((response) => {
            if (response.status) {
              this.publishError(response, variantId);
              return;
            }

            this.updateCartSilently(cart, response);
            this.markAdded(button);

            if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
              publish(window.PUB_SUB_EVENTS.cartUpdate, {
                source: 'complementary-fbt',
                productVariantId: variantId,
                cartData: response,
              });
            }
          })
          .catch((e) => {
            console.error('[complementary-fbt]', e);
          })
          .finally(() => {
            button.classList.remove('is-loading');
            button.removeAttribute('aria-busy');
          });
      }

      publishError(response, variantId) {
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(window.PUB_SUB_EVENTS.cartError, {
            source: 'complementary-fbt',
            productVariantId: variantId,
            errors: response.errors || response.description,
            message: response.message,
          });
        }
        console.warn('[complementary-fbt]', response.description || response.message);
      }

      refreshCartBubble() {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(`${root}?section_id=cart-icon-bubble`)
          .then((r) => r.text())
          .then((t) => {
            const fresh = new DOMParser().parseFromString(t, 'text/html').querySelector('.shopify-section');
            const current = document.getElementById('cart-icon-bubble');
            if (fresh && current) current.innerHTML = fresh.innerHTML;
          })
          .catch(() => {});
      }
    }
  );
}